import { CQAppConstant } from '../app-constants';

/**
 * Returns the day, month, and year parts of a date formatted for the given locale,
 * with the month abbreviated (e.g. "juil." -> "juil").
 */
export function getLocalizedDateParts(date: Date, locale?: string): { day: string; month: string; year: string } {
    const parts = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short', year: 'numeric' }).formatToParts(date);
    const getPart = (type: string) => parts.find((part) => part.type === type)?.value ?? '';
    return {
        day: getPart(CQAppConstant.DATE_PART_DAY),
        month: getPart(CQAppConstant.DATE_PART_MONTH).replace(/\.$/, ''),
        year: getPart(CQAppConstant.DATE_PART_YEAR)
    };
}

/**
 * Converts an ISO datetime (e.g. "2026-07-24T16:40:00.000Z") to the viewer's local
 * timezone and returns it in the display format "24-Jul-2026", localized to the
 * given locale (e.g. "24-juil-2026" for "fr").
 */
export function formatReleaseDate(isoDate?: string, locale?: string): string {
    if (!isoDate) {
        return CQAppConstant.NOT_AVAILABLE;
    }
    const date = new Date(isoDate);
    if (isNaN(date.getTime())) {
        return CQAppConstant.NOT_AVAILABLE;
    }
    const { day, month, year } = getLocalizedDateParts(date, locale);
    return `${day}-${month}-${year}`;
}
